export default __webpack_public_path__ + "static/src/assets/images/icons/mobiles/icon_cancel_normal@2x.png";